import PubSub from 'pubsub-js';
import { TicketActionSuccessEvent } from '../enum';
import type { TicketActionSuccessEventParam } from '../types/TicketActionSuccessEventParam';

export const ticketActionSuccessEventPubSub: PubSubJS.Base<
TicketActionSuccessEventParam,
TicketActionSuccessEvent
> = PubSub;
